import {Component, OnInit} from '@angular/core';
import {
  NavController, NavParams, LoadingController,
  AlertController, Loading
} from 'ionic-angular';
import {HospitalService} from "../../providers/hospital-service";
import {PaymentMethodService} from "../../providers/payment-service";
import {PatientService} from "../../providers/patient-service";
import {PatientPage} from "../patient/patient";

/*
 Generated class for the CreateVisit page.

 See http://ionicframework.com/docs/v2/components/#navigation for more info on
 Ionic pages and navigation.
 */
@Component({
  selector: 'page-create-patient',
  templateUrl: 'create-patient.html'
})
export class CreatePatientPage {
  loading: Loading;
  createSuccess = false;
  new_patient_id = null;
  doctor_id = parseInt(localStorage.getItem("doctor_id"))
  patient = {
    doctor: this.doctor_id,
    patient_name: '',
    payment_method: '',
    hospital_branch: '',
    hospital: ''
  };
  hospitalList: any;
  hospitalBranchList: any;
  paymentMethodList: any;


  constructor(public nav: NavController,
              public navParams: NavParams,
              private hospitalService: HospitalService,
              private paymentMethodService: PaymentMethodService,
              private patientService: PatientService,
              private alertCtrl: AlertController,
              private loadingCtrl: LoadingController) {
  }

  public createPatient() {
    this.showLoading();

    let response = this.patientService.addPatient(this.patient)

    response.subscribe(patient => {
      this.createSuccess = true
      this.new_patient_id = patient.id
      this.showPopup("Success", "Patient created")

    }, error => {
      let errors: string = "";
      for (var err in error.json()) {
        let field = err
        errors = errors + field + " " + error.json()[field] + "<br> "
      }
      this.showError(errors)
    });

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad CreateVisitPage');

  }

  ngOnInit() {

    let resp = this.hospitalService.getHospitals();

    resp.subscribe(hospitals => {
      this.hospitalList = hospitals.results
    }, error => {
      alert(error)
    });

    let pm_resp = this.paymentMethodService.getPaymentMethods()

    pm_resp.subscribe(payment_methods => {
      this.paymentMethodList = payment_methods.results
    }, error => {
      alert(error)
    });

  }

  onHospitalSelected(value) {
    let resp = this.hospitalService.getHospitalBranches(value)
    resp.subscribe(hospitalBranches => {
      this.hospitalBranchList = hospitalBranches
    }, error => {
      alert(error)
    });

  }

  showPopup(title, text) {
    setTimeout(() => {
      this.loading.dismiss();
    })

    let alert = this.alertCtrl.create({
      title: title,
      subTitle: text,
      buttons: [
        {
          text: 'OK',
          handler: data => {
            if (this.createSuccess) {
              this.nav.push(PatientPage, {
                patient_id:this.new_patient_id
              });
            }
          }
        }
      ]
    });
    alert.present(prompt);
  }

  showLoading() {
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
  }


  showError(text) {
    setTimeout(() => {
      this.loading.dismiss();
    })

    let alert = this.alertCtrl.create({
      title: 'Failed',
      subTitle: text,
      buttons: ['OK']
    });

    alert.present(prompt)
  }


}



// WEBPACK FOOTER //
// ./src/pages/create-patient/create-patient.ts